export { default } from './Snackbar';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Snackbar/index.js
// module id = 557
// module chunks = 2